import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiCookie, mdiCheckCircleOutline, mdiCloseCircleOutline, mdiClose } from '@mdi/js';
import './cookie_banner.css';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const cookies = document.cookie;
    const aceito = cookies.includes("lgpd_consent=aceito");
    const rejeitado = cookies.includes("lgpd_consent=rejeitado");

    if (!aceito && !rejeitado) {
      setVisible(true);
    }
  }, []);

  const aceitarTodos = () => {
    document.cookie = "lgpd_consent=aceito; max-age=315360000; path=/; SameSite=Lax";
    setVisible(false);
  };

  const rejeitarTodos = () => {
    document.cookie = "lgpd_consent=rejeitado; max-age=315360000; path=/; SameSite=Lax";
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner-container">
      <div className="cookie-banner-box">
        <button className="cookie-banner-close" onClick={rejeitarTodos} title="Fechar">
          <Icon path={mdiClose} size={0.8} />
        </button>

        <div className="cookie-banner-header">
          <div className="cookie-banner-icon">
            <Icon path={mdiCookie} size={1.1} color="#fc7b44" />
          </div>
          <h3>Uso de Cookies</h3>
        </div>

        <p className="cookie-banner-text">
          Utilizamos cookies para melhorar sua experiência, personalizar conteúdo e analisar o tráfego do Me LocalizaÊ. 
          Saiba mais em nossa <Link to="/PoliticaPrivacidade">Política de Privacidade</Link>.
        </p>

        <div className="cookie-banner-actions">
          <button className="cookie-btn-reject" onClick={rejeitarTodos}>
            <Icon path={mdiCloseCircleOutline} size={0.75} />
            Rejeitar todos
          </button>

          <button className="cookie-btn-accept" onClick={aceitarTodos}>
            <Icon path={mdiCheckCircleOutline} size={0.75} />
            Aceitar todos
          </button>
        </div>
      </div>
    </div>
  );
}
